import { inject, InjectionToken } from '@angular/core';
import { type CanActivateChildFn, type CanActivateFn } from '@angular/router';
import { authenticationLocalGuard } from './adapters/authentication-local.guard';

export const AUTH_GUARD = new InjectionToken<CanActivateFn | CanActivateChildFn>('AuthGuard', {
  factory: () => authenticationLocalGuard,
});

export const authenticationGuard: CanActivateFn = (route, state) => {
  const guard = inject(AUTH_GUARD);
  return guard(route, state);
};
